// extracted by mini-css-extract-plugin
export default {"container":"popupChange_container__RrWVf","content":"popupChange_content__4KyaY"};